import React from 'react';
import { Helmet } from 'react-helmet-async';

const LocalBusinessSchema = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://bagi.rs/#localbusiness",
    "name": "BAGI Trans",
    "alternateName": "BAGI",
    "description": "BAGI Trans - Vaš pouzdani partner za prodaju bagera i građevinske mehanizacije. 28 godina iskustva u prodaji polovnih i novih građevinskih mašina.",
    "url": "https://bagi.rs",
    "logo": "https://bagi.rs/logo.png",
    "image": [
      "https://bagi.rs/logo.png",
      "https://bagi.rs/static/media/aboutus.png"
    ],
    "telephone": "+381 69 800 31 28",
    "email": "info@bagi.rs",
    "foundingDate": "1990",
    "numberOfEmployees": {
      "@type": "QuantitativeValue",
      "value": "15-50"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Nikole Tesle 165A",
      "addressLocality": "Kraljevo",
      "postalCode": "36000",
      "addressRegion": "Raška oblast",
      "addressCountry": "RS"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 43.762128136620646,
      "longitude": 20.646504110462566
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "17:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "08:00",
        "closes": "14:00"
      }
    ],
    "priceRange": "$$",
    "currenciesAccepted": "RSD, EUR",
    "paymentAccepted": "Cash, Bank Transfer, Credit Card",
    "areaServed": {
      "@type": "Country",
      "name": "Serbia"
    },
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 43.762128136620646,
        "longitude": 20.646504110462566
      },
      "geoRadius": "500000"
    },
    "sameAs": [
      "https://www.facebook.com/bagitrans/",
      "https://www.instagram.com/bagi.trans/",
      "https://www.youtube.com/@dejanlazarevic6509"
    ],
    "makesOffer": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Product",
          "name": "Građevinska mehanizacija",
          "description": "Polovni i novi bageri, utovarivači i druga građevinska mehanizacija"
        },
        "businessFunction": "http://purl.org/goodrelations/v1#Sell"
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Servis građevinske mehanizacije",
          "description": "Profesionalni servis i održavanje građevinskih mašina"
        },
        "businessFunction": "http://purl.org/goodrelations/v1#Maintain"
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Konsalting",
          "description": "Stručni konsalting vezan za oblast građevinarstva"
        },
        "businessFunction": "http://purl.org/goodrelations/v1#Maintain"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Katalog građevinske mehanizacije",
      "itemListElement": [
        {
          "@type": "OfferCatalog",
          "name": "Bageri",
          "description": "Polovni i novi bageri različitih marki"
        },
        {
          "@type": "OfferCatalog", 
          "name": "Utovarivači",
          "description": "Utovarivači za građevinske radove"
        },
        {
          "@type": "OfferCatalog",
          "name": "Rezervni delovi",
          "description": "Rezervni delovi za građevinsku mehanizaciju"
        }
      ]
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Zadovoljan kupac"
        },
        "reviewBody": "Profesionalna usluga i kvalitetna mehanizacija. Preporučujem BAGI Trans za sve koji traže pouzdane građevinske mašine.",
        "datePublished": "2024-01-15"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "150",
      "bestRating": "5",
      "worstRating": "1"
    },
    "slogan": "Vaš pouzdani partner za prodaju bagera i građevinske mehanizacije",
    "keywords": "prodaja bagera, građevinska mehanizacija, polovni bageri, novi bageri, utovarivači, servis mašina, BAGI Trans, Kraljevo"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
